/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBiomarkerDto
 */
export interface CreateBiomarkerDto {
    /**
     * Date of the biomarker measurement
     * @type {Date}
     * @memberof CreateBiomarkerDto
     */
    date: Date;
    /**
     * Name of the biomarker
     * @type {string}
     * @memberof CreateBiomarkerDto
     */
    name: string;
    /**
     * Value of the biomarker
     * @type {string}
     * @memberof CreateBiomarkerDto
     */
    value: string;
    /**
     * Reference range for the biomarker
     * @type {string}
     * @memberof CreateBiomarkerDto
     */
    referenceRange: string;
    /**
     * Unit of measurement
     * @type {string}
     * @memberof CreateBiomarkerDto
     */
    unit?: string;
    /**
     * Whether the value is out of range
     * @type {boolean}
     * @memberof CreateBiomarkerDto
     */
    outOfRange?: boolean;
}

/**
 * Check if a given object implements the CreateBiomarkerDto interface.
 */
export function instanceOfCreateBiomarkerDto(value: object): value is CreateBiomarkerDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('referenceRange' in value) || value['referenceRange'] === undefined) return false;
    return true;
}

export function CreateBiomarkerDtoFromJSON(json: any): CreateBiomarkerDto {
    return CreateBiomarkerDtoFromJSONTyped(json, false);
}

export function CreateBiomarkerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBiomarkerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'name': json['name'],
        'value': json['value'],
        'referenceRange': json['referenceRange'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'outOfRange': json['outOfRange'] == null ? undefined : json['outOfRange'],
    };
}

export function CreateBiomarkerDtoToJSON(json: any): CreateBiomarkerDto {
    return CreateBiomarkerDtoToJSONTyped(json, false);
}

export function CreateBiomarkerDtoToJSONTyped(value?: CreateBiomarkerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ((value['date']).toISOString()),
        'name': value['name'],
        'value': value['value'],
        'referenceRange': value['referenceRange'],
        'unit': value['unit'],
        'outOfRange': value['outOfRange'],
    };
}

